import rightchevron from "./rightchevron.svg";
import disabledrightchevron from "./disabledrightchevron.svg";

export default function RightChevronIcon({disabled}) {
  return (
    <img src={disabled ? disabledrightchevron : rightchevron} />
  );
}